<template>
  <div class="memory-slot">
    <div @click="open = !open" class="memory-slot__title">
      <svgicon
        class="memory-slot__title-icon"
        icon="archive"
        width="22"
        height="18"
        color="#fff"
      >
      </svgicon>
      Memory Slot {{ memorySlot.nr }}
      <transition name="fade" mode="out-in">
        <span v-if="!open" class="memory-slot__title--count">
          {{ countVideos() }}
        </span>
        <span v-if="open" class="memory-slot__title--close">
          <svgicon
            class="memory-slot__title-close"
            icon="x"
            width="26"
            height="26"
            color="#fff"
          >
          </svgicon>
        </span>
      </transition>
    </div>
    <transition name="fade">
      <div v-show="open" class="memory-slot__content" :class="{ open: open }">
        <div
          v-for="video in memorySlot.content"
          class="memory-slot__video"
          :key="video.id"
        >
          <svgicon
            class="memory-slot__video-icon"
            icon="video"
            width="22"
            height="18"
            color="#fff"
          >
          </svgicon>
          <div class="memory-slot__video-title">
            <a
              @click="
                followVideo({
                  videoId: video.id,
                  videoTitle: video.title,
                  cuePoints: video.cuePoints,
                  memoryNr: memorySlot.nr
                })
              "
              >{{ video.title }}</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import "@/compiled-icons/archive";
import "@/compiled-icons/video";
import "@/compiled-icons/x";

export default {
  name: "MemorySlot",
  props: {
    memorySlot: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    countVideos() {
      return this.memorySlot.content.length;
    },
    followVideo(payload) {
      this.$store.dispatch("followVideoFromMemory", payload).then(() => {
        this.$store.commit("closeMenu");
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";
.memory-slot {
  &__title {
    cursor: pointer;
    border-bottom: 1px solid $color-gray-dd;
    background-color: $color-gray-d;
    padding: 15px;
    background-position: 15px;
    position: relative;

    &-icon {
      position: absolute;
      left: 15px;
      top: 34%;
    }

    &--count,
    &--close {
      width: 25px;
      display: inline-block;
      text-align: center;
      position: absolute;
      right: 15px;
    }

    &--count {
      background-color: $color-gray-l;
      border-radius: 20px;
    }
  }

  &__content {
    display: block !important;
    max-height: 0;
    transition: max-height 0.2s ease-out;
    overflow: hidden;

    &.open {
      transition: max-height 0.5s ease-in;
      max-height: 500px;
    }
  }
  &__video {
    padding: 10px 15px 10px 39px;
    margin-left: 16px;
    position: relative;
    text-align: left;

    &-title {
      cursor: pointer;
    }

    &-icon {
      position: absolute;
      left: 0;
      top: 13px;
    }

    a {
      color: $color-neutral;
    }
  }
}

.fade-enter-active {
  animation: fade 0.7s;
}
.fade-leave-active {
  animation: fade 0.7s reverse;
}

@keyframes fade {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
